//cart
export const cartTableHead = ["Product", "Product Name", "Price", "Quantity", "Action", "Total"];

//checkout
export const countryMenu = ["India", "South Africa", "United State", "Australia"];

//pricing
export const becomeMemberData = [
    {
        id: 1,
        title: 'Standard',
        amount: 10,
        content: '50GB Disk Space'
    },
    {
        id: 2,
        title: 'Premium',
        amount: 20,
        content: '10% on all product'
    },
    {
        id: 3,
        title: 'Auther pack',
        amount: 50,
        content: 'Upload 50 product'
    },
    {
        id: 4,
        title: 'Auther pack',
        amount: 50,
        content: 'Upload 50 product'
    },
];

export const simplePricingData = [
    {
        id: 1,
        title: 'Standard',
        amount: 15
    },
    {
        id: 2,
        title: 'Business',
        amount: 25
    },
    {
        id: 3,
        title: 'Premium',
        amount: 35
    },
    {
        id: 4,
        title: 'Extra',
        amount: 45
    },
];